import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";


const PrevButton = ({ className = "" }) => {
    return (
        <FontAwesomeIcon icon={faArrowLeft} className={`text-turquesa text-xl absolute top-6 left-64 ${className}`} />
    );
};

export default PrevButton;
